import { render } from "./index.vue?vue&type=template&id=0a5902d5&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

const cssModules = {}
import style0 from "./index.vue?vue&type=style&index=0&id=0a5902d5&lang=less&module=true"
cssModules["$style"] = style0

import exportComponent from "/var/jenkins_home/workspace/air8-client-web(ali-prod)/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__